function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["searchClient", "queryLanguages", "attributesForPrediction", "nbHits", "renderDebounceTime", "searchDebounceTime", "answersComponent"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { createClassNames } from "../core/utils.js";
import useAnswers from "../hooks/useAnswers.js";
var cx = createClassNames('Answers');

/* eslint-disable react/prop-types */
function DefaultAnswersComponent(_ref) {
  var isLoading = _ref.isLoading,
    hits = _ref.hits;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('', hits.length === 0 && '-empty')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('header')
  }), isLoading ? /*#__PURE__*/React.createElement("div", {
    className: cx('loader')
  }) : /*#__PURE__*/React.createElement("ul", {
    className: cx('list')
  }, hits.map(function (hit, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: cx('item')
    }, JSON.stringify(hit));
  })));
}
export default function Answers(_ref2) {
  var searchClient = _ref2.searchClient,
    queryLanguages = _ref2.queryLanguages,
    attributesForPrediction = _ref2.attributesForPrediction,
    _ref2$nbHits = _ref2.nbHits,
    nbHits = _ref2$nbHits === void 0 ? 1 : _ref2$nbHits,
    renderDebounceTime = _ref2.renderDebounceTime,
    searchDebounceTime = _ref2.searchDebounceTime,
    _ref2$answersComponen = _ref2.answersComponent,
    AnswersComponent = _ref2$answersComponen === void 0 ? DefaultAnswersComponent : _ref2$answersComponen,
    extraParameters = _objectWithoutProperties(_ref2, _excluded);
  var _useAnswers = useAnswers(_objectSpread({
      searchClient: searchClient,
      queryLanguages: queryLanguages,
      attributesForPrediction: attributesForPrediction,
      nbHits: nbHits,
      renderDebounceTime: renderDebounceTime,
      searchDebounceTime: searchDebounceTime
    }, extraParameters)),
    hits = _useAnswers.hits,
    isLoading = _useAnswers.isLoading;
  return /*#__PURE__*/React.createElement(AnswersComponent, {
    hits: hits,
    isLoading: isLoading
  });
}
/* eslint-enable react/prop-types */


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-instantsearch-dom/dist/es/widgets/Answers.js
// module id = 659
// module chunks = 1